<template>
  <v-tabs
    v-if="isEditMode"
    grow
    data-tourid="routineForm-step-checklistTab"
    class="routine-edit-tabs rounded-b-0 rounded-t-sm"
    :value="activeTabIndex"
  >
    <v-tab :ripple="false" @click="$emit('change', STEPS.ROUTINE)">
      <p
        class="ma-0 pa-0"
        :class="{
          'blue-grey--text text--darken-3': currentStep === STEPS.ROUTINE,
        }"
      >
        {{ $t('routines.routine_step') }}
        <v-tooltip top v-if="!formIsValid && currentStep !== STEPS.ROUTINE">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" color="red" class="ms-2">mdi-alert </v-icon>
          </template>
          {{ $t('routines.tooltip_missing_fields') }}
        </v-tooltip>
      </p>
    </v-tab>
    <v-tab
      data-tourid="routineForm-step-checklistTab"
      :ripple="false"
      :disabled="isLoading"
      @click="$emit('change', STEPS.CHECKLIST)"
    >
      <p
        class="ma-0 pa-0"
        :class="{
          'blue-grey--text text--darken-3': currentStep === STEPS.CHECKLIST,
        }"
      >
        {{ $t('routines.checklist_step') }}
        <v-tooltip
          top
          v-if="!checklistIsValid && currentStep !== STEPS.CHECKLIST"
        >
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" color="red" class="ms-2">mdi-alert </v-icon>
          </template>
          {{ $t('routines.tooltip_missing_fields') }}
        </v-tooltip>
      </p>
    </v-tab>
    <v-tab
      :ripple="false"
      :disabled="isLoading"
      @click="$emit('change', STEPS.SCORING)"
    >
      <p
        class="ma-0 pa-0"
        :class="{
          'blue-grey--text text--darken-3': currentStep === STEPS.SCORING,
        }"
      >
        {{ $t('routines.scoring.step') }}
        <v-tooltip
          v-if="showScoringWarning"
          data-testid="routineFormNavigation-tooltip-scoringWarning"
          top
        >
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              data-testid="routineFormNavigation-icon-scoringWarning"
              color="red"
              class="ms-2"
            >mdi-alert </v-icon>
          </template>
          {{ scoringErrorTitle }}
        </v-tooltip>
      </p>
    </v-tab>
  </v-tabs>
  <Stepper
    v-else
    class="my-2"
    hasCompleteError
    :steps="STEPS"
    :phases="phases"
    :activeStep="currentStep"
    @click="goToStep($event, 'stepper')"
  />
</template>

<script>
import Stepper from '@/components/Stepper'

const STEPS = {
  ROUTINE: 1,
  CHECKLIST: 2,
  SCORING: 3,
  CONFIRMATION: 4,
}

export default {
  name: 'RoutineFormNavigation',

  components: {
    Stepper,
  },

  props: {
    isEditMode: {
      type: Boolean,
      default: false,
    },
    formIsValid: {
      type: Boolean,
      default: true,
    },
    currentStep: {
      type: Number,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    checklistIsValid: {
      type: Boolean,
      default: true,
    },
    phases: {
      type: Array,
    },
    hasCompleteError: Boolean,
  },

  data() {
    return {
      STEPS,
    }
  },

  computed: {
    activeTabIndex() {
      return Math.max((this.currentStep || STEPS.ROUTINE) - 1, 0)
    },

    scoringPhase() {
      return this.phases?.find?.(phase => phase.id === STEPS.SCORING)
    },

    scoringErrorTitle() {
      return (
        this.scoringPhase?.errorTitle || this.$t('routines.tooltip_missing_fields')
      )
    },

    showScoringWarning() {
      return this.scoringPhase?.missingFields && this.currentStep !== STEPS.SCORING
    },
  },

  methods: {
    goToStep(step) {
      this.$emit('change', step)
    },
  },
}
</script>
<style lang="scss">
.routine-edit-tabs {
  box-shadow: 0px 0px 2px 0px rgba(113, 128, 150, 0.14),
    0px 0px 4px 0px rgba(113, 128, 150, 0.12);
  .v-tabs-slider-wrapper {
    height: 4px !important;
  }
}
</style>
